import { render } from "./ClauseComparison.vue?vue&type=template&id=f660e828&scoped=true"
import script from "./ClauseComparison.vue?vue&type=script&lang=js"
export * from "./ClauseComparison.vue?vue&type=script&lang=js"

import "./ClauseComparison.vue?vue&type=style&index=0&id=f660e828&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f660e828"],['__file',"src/components/offersDetails/ClauseComparison.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f660e828"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f660e828', __exports__)) {
    api.reload('f660e828', __exports__)
  }
  
  module.hot.accept("./ClauseComparison.vue?vue&type=template&id=f660e828&scoped=true", () => {
    api.rerender('f660e828', render)
  })

}


export default __exports__